// the task list the pool reads, filtered and paginated by the API
export const POOL_TASKS_PATH = 'work-packages/elements/list/tasks';

export const POOL_PER_PAGE = 25;

export const emptyPoolFilter = {
  search: '',
  projectIds: [],
  // the pool opens on the tasks nobody has taken yet
  withoutUsers: true,
  sortBy: null,
  sortOrder: null,
};

// default direction per sort field
const sortOrderMap = {
  priority: 'desc',
  effortScore: 'desc',
  deadline: 'asc',
  createdAt: 'desc',
};

/**
 * Query for POOL_TASKS_PATH.
 * usersProjects limits the result to the projects of userId.
 */
export function buildPoolQuery(filter = {}, { usersProjects, userId } = {}) {
  const { search, projectIds, userIds, withoutUsers, sortBy, sortOrder } =
    filter;

  // the pool is about work still to be done
  const parts = ['status[eq]=0'];

  if (usersProjects) {
    parts.push('usersProjects=true');
    if (userId) parts.push(`userId=${userId}`);
  }

  if (search?.trim()) parts.push(`search=${encodeURIComponent(search.trim())}`);

  // the API repeats the key instead of taking a list
  (projectIds || []).forEach((id) => parts.push(`projectId[eq]=${id}`));
  (userIds || []).forEach((id) => parts.push(`userIds[]=${id}`));

  if (withoutUsers) parts.push('withoutUsers=true');

  if (sortBy) {
    parts.push(`sortBy=${sortBy}`);
    parts.push(`sortOrder=${sortOrder || sortOrderMap[sortBy] || 'desc'}`);
  }

  return parts.join('&');
}

// Pagination follows meta.links, which carry the page only - without the
// filter appended, turning a page would drop it
export function withQueryOnLinks(payload, query) {
  if (!payload?.meta?.links) return payload;

  return {
    ...payload,
    meta: {
      ...payload.meta,
      links: payload.meta.links.map((link) => ({
        ...link,
        url: link.url ? `${link.url}&${query}` : null,
      })),
    },
  };
}
